import React from 'react';
import { DEPLOYMENT_STATUS } from 'Common/enums';
import useGetLatestDeployProcess from 'Hooks/query-hooks/deployment/useGetLatestDeployProcess';

const useIsDeploying = (
    shouldFetch?: boolean,
    onSuccess?: (data?: DeploymentProcess) => void,
    onError?: (err: any) => void
) => {
    const [shouldPoll, setShouldPoll] = React.useState(false);
    useGetLatestDeployProcess(
        shouldPoll,
        shouldFetch,
        // onSuccess
        (deploymentProcess) => {
            const isDeploying =
                deploymentProcess?.status === DEPLOYMENT_STATUS.STARTED && !deploymentProcess?.details?.simulationId;
            const isDeployFailed = deploymentProcess?.status === DEPLOYMENT_STATUS.FAILED;

            // if error occurs while polling for deploy throw an error modal
            if (shouldPoll && isDeployFailed) {
                onError?.(deploymentProcess);
            }

            if (isDeploying && !shouldPoll) {
                setShouldPoll(true);
            }
            // this makes it so it only run once when previous state was true
            else if (!isDeploying && shouldPoll) {
                onSuccess?.(deploymentProcess);
                setShouldPoll(false);
            }
        },
        // onError
        (err) => {
            if (shouldPoll) {
                setShouldPoll(false);
            }
            // polling shouldn't show error modal when re-auth flow fails
            if (err && (err as any).code !== 403 && (err as any).code !== 401) {
                onError?.(err);
            }
        }
    );

    return shouldPoll;
};

export default useIsDeploying;
